import React from "react";

import {
    Button,
    HelpCircle,
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@formant/ui-kit";

interface ICommandTemplateHeaderProps {
    toggleView: () => void;
    view: "list" | "create";
}

export const CommandTemplateHeader: React.FC<ICommandTemplateHeaderProps> = ({
    toggleView,
    view,
}) => {
    return (
        <div className="flex items-center justify-between p-4 border-b border-slate-800">
            <div className="flex items-center gap-2">
                <h1 className="text-xl font-medium">Commands</h1>
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger>
                            <HelpCircle className="h-5 w-5" />
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>
                                A command is a directive to the device to
                                perform a specific task. You could use the
                                built-in commands (available by default) or
                                create custom commands (built using Formant
                                APIs). Drag commands to set the order operators
                                see in Issue a Command.
                            </p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            </div>
            <Button className="" onClick={toggleView}>
                {view === "list" ? "ADD COMMAND" : "CANCEL"}
            </Button>
        </div>
    );
};
